/// <amd-module name="Test/TestPlansHubRefresh/SuitesMenu/SuitesMenuProviderService" />
import * as Resources from "Test/TestPlansHubRefresh/SuitesMenu/Resources";
import { ISuitesMenu } from "Test/TestPlansHubRefresh/SuitesMenu/SuitesMenu.Types";
import { TestSuiteType } from "TestPlanCommon/Contracts/TestPlan";
import { getMenuItems, IMenuService } from "VSS/Features/PlatformUI/ContributedMenu";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IIconProps } from "VSSUI/Icon";
import { IMenuItem, IMenuProps } from "VSSUI/Menu";
import { ISuitesMenuService, openDeleteTestSuiteDialog, openExportHTMLDialog, openRequirementWorkitem, renameTestSuite } from "./SuitesMenuService";

class SuitesMenuProviderService extends VssService implements IMenuService {
    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this.pageContext = pageContext;
    }

    public _serviceRestart(pageContext: IVssPageContext): void {
        super._serviceRestart(pageContext);
    }

    public getMenuItems(menuId: string, props: ISuitesMenu): IMenuItem[] | null {
        const menuItems: IMenuItem[] = [];

        if (menuId === "ms.vss-test-web.suite-list-menu" || menuId === "ms.vss-test-web.root-suite-list-menu") {
            if (props.suite.type == TestSuiteType.StaticTestSuite) {
                menuItems.push({
                    id: "new-suite-menu-item",
                    text: Resources.NewSuiteText,
                    iconProps: {
                        iconName: "FabricNewFolder",
                        className: "new-folder-icon"
                    } as IIconProps,
                    subMenuProps: {
                        id: "new-suite-submenu",
                        items: getMenuItems(this.pageContext, "ms.vss-test-web.new-suite-submenu", props)
                    } as IMenuProps,
                    rank: 1
                });

                menuItems.push({
                    id: "import-test-suites",
                    text: Resources.ImportTestSuitesText,
                    iconProps: {
                        iconName: "Import",
                        className: "import-icon"
                    } as IIconProps,
                    onActivate: (menuItem: IMenuItem) => {
                        if (props.testSuiteImportPanelOpen) {
                            props.testSuiteImportPanelOpen();
                        }
                    },
                    rank: 6,
                    data: props
                });
            }

            if (props.suite.type == TestSuiteType.RequirementTestSuite) {
                menuItems.push({
                    id: "view-requirement-menu-item",
                    text: Resources.ViewRequirementText,
                    iconProps: {
                        iconName: "ReadingMode",
                        className: "reading-mode-icon"
                    } as IIconProps,
                    onActivate: (menuItem: IMenuItem) => {
                        openRequirementWorkitem(props);
                    },
                });
            }

            // Only add delete and rename menu items for non root suites
            if (props.suite.id != props.rootSuiteId) {
                menuItems.push({
                    id: "rename-suite-menu-item",
                    text: Resources.RenameSuiteText,
                    iconProps: {
                        iconName: "Rename",
                        className: "rename-folder-icon"
                    } as IIconProps,
                    onActivate: (menuItem: IMenuItem) => {
                        renameTestSuite(props);
                    },
                    rank: 4,
                    data: props
                });
                menuItems.push({
                    id: "delete-suite-menu-item",
                    text: Resources.DeleteSuiteText,
                    iconProps: {
                        iconName: "Delete",
                        className: "delete-icon"
                    } as IIconProps,
                    onActivate: (menuItem: IMenuItem) => {
                        openDeleteTestSuiteDialog(props);
                    },

                    rank: 5,
                    data: props
                });
            }

            menuItems.push({
                id: "assign-testers-to-run-all-tests",
                text: Resources.AssignTestersToRunAllTests,
                iconProps: {
                    iconName: "People",
                    className: "people-icon"
                } as IIconProps,
                onActivate: (menuItem: IMenuItem) => {
                    const suitesMenuService = this.pageContext.getService<ISuitesMenuService>("ISuitesMenuService");
                    suitesMenuService.assignTestersToSuite(props);
                },
                rank: 3,
                data: props
            });
            menuItems.push({
                id: "export-test-suite",
                text: Resources.ExportSuiteText,
                iconProps: {
                    iconName: "Print",
                    className: "print-icon"
                } as IIconProps,
                onActivate: (menuItem: IMenuItem) => {
                    openExportHTMLDialog(props);
                },
                rank: 2,
                data: props
            });

            return menuItems;
        }
        return null;
    }
}

Services.add("new-suite-menu-provider", { serviceFactory: SuitesMenuProviderService });
